export default "__VITE_ASSET__1KwUPtpE__"